import styled from 'styled-components';
import {BGImageCenter, LIGHT_BLUE4, LIGHT_GRAY4} from '../../../../../../../../globalVariables/GlobalVariables';
import {alignCenter, dFlex} from '../../../../../../../../globalVariables/GlobalFlex';

export const event = styled.div`
    ${dFlex}
    border-bottom: 0.5px solid ${LIGHT_GRAY4};
    padding-block: 5px;
    padding-inline: 15px;
`;

export const link = styled.a`
    ${dFlex}
    ${alignCenter}
    gap: 5px;
    text-decoration: none;
    color: inherit;
`;

export const circle = styled.div`
    width: 6px;
    height: 6px;
    flex-shrink: 0;
    background-color: ${LIGHT_BLUE4};
    border-radius: 50%;
`;

export const shareIcon = styled.div<{$icon: string}>`
    width: 10px;
    height: 10px;
    ${p => BGImageCenter(p.$icon, 'cover')}
`;

export const eventList = styled.div`
    margin: 0;
    padding: 0;
    width: 100%;
    margin-bottom: 10px;
`; 